export default {
  defaultLocale: "he-IL", // 'he-IL', 'en-US'
  availableLocales: ["he-IL", "en-US"],
};
